import { ToastContainer } from '@bfe/moly';
import { useLocale } from '../../store/i18nMessage';
import { isInfraDemoPage } from '../../utils/trick';
// import { Web3Search } from '../Web3Search';
import { WalletState } from './WalletState';
import { AssetsDrop } from './AssetsDrop';
import { DialogContainer } from './DialogContainer';
import { DownloadApp } from './DownloadApp';
import { LocaleSelector } from './LocaleSelector';
import { MainSiteWeb3Switch } from './MainSiteWeb3Switch';
import { MenuList } from './Menu/MenuList';
import './style.scss';
import { memberInfoStore } from '../../store/memberInfo';
import { useEffect } from 'react';
import { web3Navigate } from '@web3/utils';
import { TRADE_PATH } from '../../utils/url';
import { useScreen } from '../../store/screen';
import { MobileHeader } from './MobileHeader';
import { When } from 'react-if';
import { Web3SeoHead } from '../Web3SeoHead';
import { useGoogleScript } from '@web3/hooks';
import { initAdaBot } from '@web3/base-utils';

export type Web3HeaderProps = {
  // 是否接受demo用户（默认是false），demo用户会给跳转到现货交易站
  acceptDemoUser?: boolean;
  // 是否渲染seo meta标签到header，默认false，默认让大家去走 nginx ssr那套
  renderSeoMeta?: boolean;
  // 切换语言是否需要刷新页面
  refreshWhenChangeLocale?: boolean;
  noSEO?: boolean;
  //其它属性支持 等提需求吧
};

export function Web3Header({ acceptDemoUser = false, renderSeoMeta = true, refreshWhenChangeLocale = false, noSEO = false }: Web3HeaderProps) {
  const { hasMessage } = useLocale();
  const { memberInfo } = memberInfoStore.useStoreState();
  const screen = useScreen();
  useGoogleScript();
  initAdaBot();
  useEffect(() => {
    initAdaBot();
  }, []);

  useEffect(() => {
    if (acceptDemoUser) {
      return;
    }
    // demo user跳转到 交易页
    if (memberInfo?.isDemo) {
      web3Navigate(TRADE_PATH);
    }
  }, [memberInfo, acceptDemoUser]);

  return (
    <>
      <ToastContainer />
      <header id="web3-header" className="web3-header-container">
        {!noSEO && <Web3SeoHead renderHead={renderSeoMeta} />}
        <When condition={hasMessage()}>
          {screen.md ? (
            <MobileHeader />
          ) : (
            <>
              <div className="flex items-center">
                <MainSiteWeb3Switch />
                <MenuList />
              </div>
              {/* <Web3Search className="ltr:ml-2 rtl:mr-2" /> */}
              <div className="flex items-stretch h-full ltr:ml-auto rtl:mr-auto ">
                <WalletState />
                <AssetsDrop />
                <DownloadApp />
                <LocaleSelector changeRote={!isInfraDemoPage} refreshWhenChangeLocale={refreshWhenChangeLocale} />
              </div>
              <DialogContainer />
            </>
          )}
        </When>
      </header>
    </>
  );
}
